// Path: src\Components\Contest\ContestBox\ContestBox.jsx
import { React, useState } from "react";
import WinningBreakup from "../../Popup/WinningPopup";
import TournamentJoiningPopup from "../../Popup/JoiningPopup";
import tournamentlist from "../../../images/tournamentlist.png";
import Diamond from "../../../images/Diamond.png"
import arrow from "../../../images/rightside.png"
import { toastInfo } from '../../../Utilities/toast'
import { useTranslation } from 'react-i18next'


import { zformatDate, zformatTime } from "../../../Utilities/helper";

import { useEffect } from "react";
import { base_apis, url } from "../../../config/url";
const ContestBox = (props) => {
  const { t } = useTranslation();
  const [isInputVisible, setIsInputVisible] = useState(false);
  const [isTournamentJoiningPopup, setisTournamentJoiningPopup] = useState(false);
  // const totalPlayers = 200; // Example total number of players
  // const joinedPlayers = 72; // Example number of players who have joined
  const [isPricePointPoolModel, setPricePointPool] = useState(false);
  const [winningbrarkupContest, setWinningBrarkupContest] = useState(null);

  // const percentage =  // Calculate percentage
  const [contestData, setContestData] = useState(props.contestData);
  const [index, setindex] = useState(props.index);
  const toggleInputVisibility = () => {
    setIsInputVisible(!isInputVisible);
  };

  const findValueByName = (data, nameToFind) => {

    if (data && data.length > 0) {
      const result = data.find(item => item.name === nameToFind);
      return result ? result.value : 'N/A'; // Return the value if found, otherwise return null
    } else {
      return 'N/A'
    }

  };
  const getCurrencyImg = (data, currencyType) => {
    let result;
    if (currencyType === "outCurrency") {
      result = data.find(item => item?.[currencyType]?.img?.default);
      return result ? `${base_apis?.imageUrl}${result.outCurrency.img.default}` : Diamond;
    } else if (currencyType === "inCurrency") {
      result = data.find(item => item?.[currencyType]?.img?.default);
      return result ? `${base_apis?.imageUrl}${result.inCurrency.img.default}` : Diamond;
    }


  };
  const showWinningBreakup = (contestId) => {
    if (contestId) {
      setWinningBrarkupContest(contestId)
      setPricePointPool(true)
    } else {
      setWinningBrarkupContest(null)
      setPricePointPool(false)
    }
  };

  const totalPlayers = contestData?.totalPlayers || 0; // Example total number of players
  const joinedPlayers = contestData?.totalJoinedPlayers || 0; // Example number of players who have joined
  const remainingPlayers = totalPlayers - joinedPlayers;

  return (
    <>
      {/* {console.log("T-", contestData?.title, "I-", index)} */}
      {contestData && contestData?._id &&

        <div className="container tournament-card--wrap mt-4">

          <div className="tournament-card tournament-card-contest mb-4">

            <div className="card-body d-flex flex-column justify-content-between mb-4">
              <div className="d-flex justify-content-between align-items-center">
                <div className="card-title">
                {contestData?.title.length > 18 ? (
                                        // scrolldelay="200" for delay marquee
                                        <marquee >
                                            {contestData?.title || 'N/A'}
                                        </marquee>
                                      ) : (
                                        contestData?.title || 'N/A'
                                      )}
                  {/* {contestData?.title || 'N/A'} */}
                
                </div>
                <button className="btn rules-btn" style={{ width: "fit-content" }}
                  onClick={() => {
                    navigator.clipboard.writeText(
                      contestData?.shortCode
                    );
                    toastInfo('short code copied')
                  }}>ID-{contestData?.shortCode || 'N/A'}</button>
                {/* TODO: need to confirm to put shortcode like ID-XXXXXX or XXXXXX*/}
              </div>
              <hr style={{margin:"0.5rem 0"}}></hr>
              <div className="row">
                <div className="col-12">
                  <div className="tournament-card-detail">
                    <div className="row">
                      {/* First row (date, round, ID) */}
                      <div className="col-12 tournament-card-box--wrap">
                        <div className="row">
                          <div className="col-3 tournament-card-box">
                            <div className="detail-item">
                              <div className="tournament-detail-label letter-spacing">
                                {contestData?.date ? zformatDate(contestData?.date) : 'N/A'}
                              </div>
                              <div className="tournament-detail-value">
                                {t('tournament_list.date')}
                              </div>
                            </div>
                          </div>
                          <div className="col-3 tournament-card-box">
                            <div className="detail-item">
                              <div className="tournament-detail-label">
                                {contestData?.date ? zformatTime(contestData?.time) : 'N/A'}
                              </div>
                              <div className="tournament-detail-value">

                                {t('tournament_list.time')}
                              </div>
                            </div>
                          </div>

                          {contestData?.titles?.[0]?.isSelection && contestData?.titles?.[0]?.name && contestData?.titles?.[0]?.value && (
                            <div className="col-3 tournament-card-box">
                              <div className="detail-item">
                                <div className="tournament-detail-label">
                                {contestData?.titles?.[0]?.value.length > 8 ? (
                  
                  <marquee >
                   {contestData?.titles?.[0]?.value}
                  </marquee>
              ) : (
                contestData?.titles?.[0]?.value
              )}
                                  {/* {contestData?.titles?.[0]?.value} */}
                                </div>
                                <div className="tournament-detail-value">
                                {contestData?.titles?.[0]?.name.length > 8 ? (
                  
                  <marquee >
                   {contestData?.titles?.[0]?.name}
                  </marquee>
              ) : (
                contestData?.titles?.[0]?.name
              )}
                                  {/* {contestData?.titles?.[0]?.name} */}
                                </div>
                              </div>
                            </div>
                          )}

                          {contestData?.titles?.[1]?.isSelection && contestData?.titles?.[1]?.name && contestData?.titles?.[1]?.value && (
                            <div className="col-3 tournament-card-box">
                              <div className="detail-item">
                                <div className="tournament-detail-label">
                                {contestData?.titles?.[1]?.value.length > 11 ? (
                  
                  <marquee >
                   {contestData?.titles?.[1]?.value}
                  </marquee>
              ) : (
                contestData?.titles?.[1]?.value
              )}
                                  {/* {contestData?.titles?.[1]?.value} */}
                                </div>
                                <div className="tournament-detail-value">
                                {contestData?.titles?.[1]?.name.length > 11 ? (
                  
                  <marquee >
                   {contestData?.titles?.[1]?.name}
                  </marquee>
              ) : (
                contestData?.titles?.[1]?.name
              )}
                                  {/* {contestData?.titles?.[1]?.name} */}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-2">
                <div className="tournament-details-winnings tournament-details-winnings-1">
                  <div className="d-flex justify-content-between">
                    <p className="prize-info">
                      {t('tournament_list.prize_pool')}
                      <span className="tournament-prizepool">{contestData?.prizePool || 'N/A'}
                        <img
                          className="currency-icon"
                          src={`${getCurrencyImg(contestData?.currency, 'outCurrency')}`}
                          alt=""
                        />
                      </span>
                    </p>
                    {/* {console.log("contestData?.winningModel", contestData?.winningModel)} */}
                    <p className="join-info">
                      {contestData?.winningModel === 'perRank' ? (
                        <>
                          {t('tournament_list.winners')}
                          <span className="tournament-prizepool">
                            {contestData?.totalWinners || 0}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="tournament-arrow-icon"
                              viewBox="0 0 20 20"
                              onClick={() => showWinningBreakup(contestData?._id)}
                              style={{ cursor: 'pointer' }} // Optional: Add 
                            >
                              <path d="M5.83288 8.33326L9.99956 12.4999L14.16622 8.33326" />
                            </svg>
                          </span>
                        </>
                      ) : contestData?.winningModel === 'perKill' ? (
                        <>
                          {t('tournament_list.per_kill')}
                          <span className="tournament-prizepool">
                            {contestData?.killPoints || 0}
                            <img
                                className="currency-icon"
                              src={url?.IMAGE_URL +
                                contestData?.currency[0]?.outCurrency?.img
                                  ?.default}
                              alt=""
                            />
                          </span>
                        </>
                      ) : (
                        <span>'N/A'</span>
                      )}
                    </p>
                    <p className="join-using">

                      {Number(contestData?.entryFee) > 0 ? (
                       <span className="tournament-prizepool" style={{ color: "#d5d6d9" }}>
                       {t('tournament_list.join_using')} 
                       <span style={{ color: "#fff" }}>{Number(contestData?.entryFee)}</span>
                       <img
                         className="currency-icon"
                         src={`${getCurrencyImg(contestData?.currency, 'inCurrency')}`}
                         alt=""
                       />
                     </span>
                     
                      ) : (
                        <>
                          <span className="tournament-prizepool" >
                            <span style={{color:"#d5d6d9"}}>{t('tournament_list.join_using')}</span> Free
                          </span>
                        </>
                      )}
                    </p>




                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between align-items-center mt-2">
                {/* Progress Bar */}
                <div
                  className="progress"
                  style={{ height: "6px", width: "100%" }}
                >
                  {/* {console.log("contestData", contestData)} */}
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{
                      width: `${(contestData.totalJoinedPlayers / contestData.totalPlayers) * 100}%`, // Dynamically set width
                      backgroundColor: "#9F6693", // Change color if 100%
                    }}
                    aria-valuenow={contestData.totalJoinedPlayers}
                    aria-valuemin="0"
                    aria-valuemax={contestData.totalPlayers}
                  ></div>
                </div>
              </div>

              <p className="progressbar-text">
                <div>{contestData.totalJoinedPlayers} {contestData.totalJoinedPlayers > 1 ? t('tournament_list.players_joined') : t('tournament_list.player_joined')}</div>
                <div>{contestData.totalPlayers}</div>
              </p>
            </div>
            {contestData.isJoined == true ?

              <div className="abs-btn--wrap">
                <button
                  className="join-now-btn"
                  onClick={() => props.onJoinedContestDetails(contestData)}
                >
                  {t('contest.joined')}
                </button>
              </div>
              : contestData?.isJoined === false && remainingPlayers === 0 ?
              <div className="abs-btn--wrap">
                <button className="join-now-btn">{t('tournament_list.full')}</button>
              </div>
              :
              <div className="abs-btn--wrap">
                <button
                  className="join-now-btn"
                  onClick={() => props.onJoinContestClick(contestData)}
                >
                  {t('contest.join_contest')}
                </button>
              </div>

            }




          </div>
        </div>

      }

      <div>
        {isPricePointPoolModel && winningbrarkupContest != null && (
          <WinningBreakup
            isOpen={isPricePointPoolModel}
            contestId={winningbrarkupContest}
            contestData={contestData}
            popupType={'contest'}
            title="Winning Breakup"
            onClose={() => setPricePointPool(false)}
          />
        )}

      </div>
    </>
  );
};

export default ContestBox;
